module.exports = __webpack_public_path__ + "swapix.png?b2321d5d665a8cb88975dc631c148a35";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swapix.png
// module id = 382
// module chunks = 2